var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditAnomaly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H16C20.4183 0 24 3.58172 24 8V16C24 20.4183 20.4183 24 16 24H8C3.58172 24 0 20.4183 0 16V8Z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8.66667V4.30667C12.6087 4.53733 13.1687 4.89267 13.6433 5.36667L15.966 7.69067C16.4407 8.16467 16.796 8.72467 17.0267 9.33333H12.6667C12.2987 9.33333 12 9.034 12 8.66667ZM12.8467 16.9867C12.3047 17.5287 12 18.2633 12 19.03V20H12.97C13.7367 20 14.4713 19.6953 15.0133 19.1533L19.5513 14.6153C20.1493 14.0173 20.1493 13.0467 19.5513 12.4487C18.9533 11.8507 17.9827 11.8507 17.3847 12.4487L12.8467 16.9867ZM10.6667 19.03C10.6667 17.902 11.106 16.8413 11.9033 16.044L16.4413 11.506C16.7007 11.2467 17.0027 11.0473 17.3287 10.9053C17.326 10.8253 17.3227 10.746 17.3173 10.666H12.6667C11.564 10.666 10.6667 9.76867 10.6667 8.666V4.016C10.5593 4.00867 10.452 4 10.3433 4H7.33333C5.49533 4 4 5.49533 4 7.33333V16.6667C4 18.5047 5.49533 20 7.33333 20H10.6667V19.03Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditAnomaly);
export default __webpack_public_path__ + "static/media/edit_anomaly.28de31d36cb0cef26255f7c9e4e23fe8.svg";
export { ForwardRef as ReactComponent };